import { motion } from "framer-motion";
import { ArrowUpRight, Sparkles } from "lucide-react";
import { HERO } from "@/data/content";
import { CtaButton, MaskReveal, handleCta } from "./primitives";

const EASE = [0.16, 1, 0.3, 1];

export default function Hero() {
  return (
    <section id="topo" className="relative overflow-hidden pt-32 pb-16 md:pt-40 md:pb-24">
      {/* subtle grid + glow backdrop */}
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(10,25,47,0.035)_1px,transparent_1px),linear-gradient(to_bottom,rgba(10,25,47,0.035)_1px,transparent_1px)] bg-[size:64px_64px] [mask-image:radial-gradient(ellipse_at_top,black,transparent_70%)]" />
        <div className="absolute -top-20 right-0 h-[420px] w-[420px] rounded-full bg-brand-gold/10 blur-[120px]" />
        <div className="absolute top-40 -left-20 h-[420px] w-[420px] rounded-full bg-brand-blue/10 blur-[120px]" />
      </div>

      <div className="mx-auto flex max-w-4xl flex-col items-center px-5 text-center lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: EASE }}
          className="inline-flex items-center gap-2 rounded-full border border-brand-gold/40 bg-brand-goldLight px-4 py-1.5"
        >
          <Sparkles className="h-3.5 w-3.5 text-brand-goldDark" />
          <span className="text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-goldDark">
            {HERO.badge}
          </span>
        </motion.div>

        <h1 className="mt-7 font-display text-4xl font-semibold leading-[1.05] tracking-tight text-brand-navy sm:text-5xl lg:text-[4rem]">
          <MaskReveal lines={HERO.headlineLines} trigger="load" />
        </h1>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: EASE, delay: 0.2 }}
          className="mt-6 max-w-2xl text-base leading-relaxed text-brand-navy/60 md:text-lg"
        >
          {HERO.subheadline}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: EASE, delay: 0.3 }}
          className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-center"
        >
          <CtaButton size="lg" onClick={() => handleCta("checkout")} data-testid="hero-cta-primary">
            {HERO.ctaPrimary}
            <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </CtaButton>
          <CtaButton size="lg" variant="outline" onClick={() => handleCta("#metodo")} data-testid="hero-cta-secondary">
            {HERO.ctaSecondary}
          </CtaButton>
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="mt-7 text-sm font-medium text-brand-navy/45"
        >
          {HERO.microline}
        </motion.p>
      </div>
    </section>
  );
}
